import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  connect() {
    this._keydownHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._keydownHandler)

    this._forceCloseHandler = () => this.forceClose()
    document.addEventListener("admin-drawer:force-close", this._forceCloseHandler)

    this.open()
  }

  disconnect() {
    document.removeEventListener("keydown", this._keydownHandler)
    document.removeEventListener("admin-drawer:force-close", this._forceCloseHandler)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    requestAnimationFrame(() => {
      this.panelTarget.classList.remove("translate-x-full")
    })
  }

  close() {
    const event = new CustomEvent("admin-drawer:before-close", { cancelable: true, bubbles: false })
    document.dispatchEvent(event)
    if (event.defaultPrevented) return
    this.forceClose()
  }

  forceClose() {
    this.panelTarget.classList.add("translate-x-full")
    document.body.classList.remove("overflow-hidden")
    this.panelTarget.addEventListener("transitionend", () => {
      this.overlayTarget.classList.add("hidden")
      const frame = document.getElementById("admin-drawer")
      if (frame) frame.innerHTML = ""
    }, { once: true })
  }

  clickOverlay(event) {
    if (event.target === this.overlayTarget) this.close()
  }
}
